module.exports = __webpack_public_path__ + "static/media/cake.aafe56f0.svg";